/* eslint-disable no-console */
import { useState, useEffect } from 'react'
import { mySalesService } from '../Services/mySalesService'

export const useReferrals = () => {
  const [referrals, setReferrals] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        setIsLoading(true)
        const referralsData = await mySalesService.getReferrals()
        setReferrals(referralsData)
        setError(null)
      } catch (err) {
        console.error('Error fetching referrals:', err)
        setError(err.message || 'Error loading referrals')
        setReferrals([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchReferrals()
  }, [])

  return {
    referrals,
    isLoading,
    error,
  }
}
